var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaisByPathogenIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.412 6.588a1.412 1.412 0 1 0 0 2.824 1.412 1.412 0 0 0 0-2.824ZM1.412 6.588a1.412 1.412 0 1 0 0 2.824 1.412 1.412 0 0 0 0-2.824ZM5.176 9.882a1.412 1.412 0 1 0 0 2.824 1.412 1.412 0 0 0 0-2.824ZM5.176 3.294a1.412 1.412 0 1 0 0 2.823 1.412 1.412 0 0 0 0-2.823ZM9.412 13.177a1.412 1.412 0 1 0 0 2.823 1.412 1.412 0 0 0 0-2.823ZM9.412 0a1.412 1.412 0 1 0 0 2.823 1.412 1.412 0 0 0 0-2.823Z"
})));
export default SvgHaisByPathogenIcon;